const polishLocale = {
    firstDayOfWeek: 1,
    months: {
        shorthand: ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"],
        longhand: [
            "Styczeń",
            "Luty",
            "Marzec",
            "Kwiecień",
            "Maj",
            "Czerwiec",
            "Lipiec",
            "Sierpień",
            "Wrzesień",
            "Październik",
            "Listopad",
            "Grudzień",
        ],
    },
};

export default {
    init: function () {
        document.querySelectorAll('[data-field_type="month"]').forEach((field) => {
            this.initField(field);
        });
    },

    initField: function (field) {
        if (field._flatpickr || typeof flatpickr === "undefined") {
            return;
        }

        flatpickr(field, {
            dateFormat: "Y-m",
            defaultDate: field.value || null,
            disableMobile: true,
            locale: polishLocale,
            monthSelectorType: "dropdown",
            onReady: (_, __, instance) => {
                instance.calendarContainer.classList.add("flatpickr-calendar--month-field");

                const submit = document.createElement("button");
                submit.type = "button";
                submit.className = "flatpickr-month-submit";
                submit.textContent = "Wybierz";
                submit.addEventListener("click", () => {
                    const month = String(instance.currentMonth + 1).padStart(2, "0");
                    field.value = `${instance.currentYear}-${month}`;
                    field.dispatchEvent(new Event("input", { bubbles: true }));
                    field.dispatchEvent(new Event("change", { bubbles: true }));
                    instance.close();
                });

                instance.calendarContainer.appendChild(submit);
            },
        });
    },
};
